import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Heart, Package, Plus } from 'lucide-react';
import PriceTag from './PriceTag';
import { useShopFavorites } from '@/context/ShopFavoritesContext';
import { useShopCart } from '@/context/ShopCartContext';

const isNew = (createdAt) => {
  if (!createdAt) return false;
  const days = (Date.now() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24);
  return days <= 14;
};

const ProductCard = ({ product, onClick }) => {
  const { addToCart } = useShopCart();
  const { isFavorite, toggleFavorite } = useShopFavorites();
  const soldOut = product.track_stock && (product.stock ?? 0) <= 0;
  const onSale = product.sale_price !== null && product.sale_price !== undefined && product.sale_price < product.price;

  return (
    <Card className="border-0 shadow-sm overflow-hidden group cursor-pointer transition-shadow hover:shadow-md">
      <div className="relative w-full aspect-square bg-slate-50 flex items-center justify-center overflow-hidden" onClick={onClick}>
        {product.image_url ? (
          <img
            src={product.image_url}
            alt={product.title}
            className="max-w-full max-h-full object-contain transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <Package className="w-10 h-10 text-slate-300" />
        )}
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {isNew(product.created_at) && <Badge className="bg-teal-600 hover:bg-teal-600">Nieuw</Badge>}
          {onSale && <Badge className="bg-red-500 hover:bg-red-500">Sale</Badge>}
          {soldOut && <Badge variant="secondary">Uitverkocht</Badge>}
        </div>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); toggleFavorite(product.id); }}
          className="absolute top-2 right-2 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center shadow-sm"
        >
          <Heart className={`w-4 h-4 ${isFavorite(product.id) ? 'fill-red-500 text-red-500' : 'text-slate-400'}`} />
        </button>
      </div>
      <CardContent className="p-4 space-y-2">
        <div onClick={onClick}>
          <h3 className="font-medium text-slate-900 line-clamp-1">{product.title}</h3>
          {product.short_description && (
            <p className="text-sm text-slate-500 line-clamp-2 mt-0.5">{product.short_description}</p>
          )}
        </div>
        <div className="flex items-center justify-between pt-1">
          <PriceTag price={product.price} salePrice={product.sale_price} />
          <Button
            size="sm"
            className="rounded-xl bg-teal-600 hover:bg-teal-700"
            disabled={soldOut}
            onClick={(e) => { e.stopPropagation(); addToCart(product); }}
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
